export default [
{
    title: 'Banner',
    customIcon: 'BannerSvg',
    children: [
      {
        title: 'Banner List',
        route: 'custom-banner-list',
        path: '/custom-banner/list/Banner_List',
      },
      {
        title: 'Banner Set List',
        route: 'custom-set-banner',
        path: '/custom-banner/set/Banner_Set',
      },
      {
        title: 'Banner Group List',
        route: 'custom-banner-group',
        path: '/custom-banner/group/Banner_Group',
      },
    ],
  },
];